// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AdobeFilledSvg from "@fishx/icons-svg/es/asn/AdobeFilled";
import FishxIcon from '../components/FishxIcon';

var AdobeFilled = function AdobeFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AdobeFilledSvg
  }));
};

AdobeFilled.displayName = 'AdobeFilled';
export default React.forwardRef(AdobeFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AdobeFilled.js
// module id = 1948
// module chunks = 0